import gql from 'graphql-tag'
import {useMutation} from '@apollo/client'

const DELETE_SAVED_FILTER = gql`
  mutation deleteSavedFilter($saved_filter_name: String!) {
    deleteSavedFilter(saved_filter_name: $saved_filter_name) {
      success
      message
      saved_filter_name
    }
  }
`

export default function useDeleteSavedFilter() {
  const [deleteSavedFilter, {data, loading, error}] = useMutation(DELETE_SAVED_FILTER, {
    errorPolicy: 'all'
  })

  return {deleteSavedFilter, data, loading, error}
}
